import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import ac7430af9e76c0555ab1fd68b591738f4b from "./generated-ac26bba4-09cd-4ce7-a3e9-b1ed31165343.json";

import a42a49049d1091ffe55b30a8c895ceae2b from "./generated-ea5dc0a0-d798-4c64-a4dc-315c77244694.json";

import a3a89b421057edae5019cc1aab97321f7b from "./generated-0046b448-16ee-4553-aec3-c31596ea1f82.json";

import abe35627c9f3771aec3a40356fd9192a8b from "./generated-8e1454e1-67f3-4dfb-9855-23319706d68b.json";

import aa059e69832cc5b443174684e01b5f461b from "./generated-50ca6429-2f06-4849-b42b-037e19e8ae7d.json";

import a42185bf01a69b2b3aa9bc33068f1b0adb from "./generated-05812850-d25e-46e9-bf4c-2eb93b429717.json";

import aac1ad1488142685c31a145d196ba70abb from "./generated-de2bd834-0bb7-4ec6-b766-7e2856d33ed2.json";

import a86ea451f8a85999d38f7a441f8a0d09cb from "./generated-589a647e-6c58-4554-b31c-daffe55831a9.json";

import ac4640c963d80f3f7338b6aa2db7f0542b from "./generated-dd177e48-2774-4f4f-b1f4-f0c209b5950a.json";

import a4271a148d563f996e5da7a07edb69a62b from "./generated-58547b5f-bdb0-4fef-acfe-0daaeec36793.json";

import aedb2f6782e88ab16ce219fed4d7e737db from "./generated-fa9e3f16-3ed0-4c5f-9280-30a388162628.json";

import a641323b7e372cfe2b32f7cc62c3e7903b from "./generated-cc155af0-8fb1-4a74-91d0-a88ae7a50b5e.json";

import ac1adf93c3498f072f95e02d484dc6d45b from "./generated-d541981e-1e94-4fd2-9697-4d8f5292ab59.json";

import ad56c128a1f423438ddf6f100f81f5a31b from "./generated-c441ee42-fa1b-410a-8b13-a97af9b0f73e.json";

import a796027f38b094748e5ec69e25050e68db from "./generated-70d26a52-e115-47e4-9c3c-5218ff1abac2.json";

import a431c106f1bbfac72024b70bc1e1434f6b from "./generated-4911a843-6988-425c-888c-ab70723ff5ab.json";

import a433a563b3f2de29990015aefc674cbfcb from "./generated-fe485941-1dea-4255-8f25-f5bdb9446d93.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(ac7430af9e76c0555ab1fd68b591738f4b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a42a49049d1091ffe55b30a8c895ceae2b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a3a89b421057edae5019cc1aab97321f7b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(abe35627c9f3771aec3a40356fd9192a8b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(aa059e69832cc5b443174684e01b5f461b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a42185bf01a69b2b3aa9bc33068f1b0adb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(aac1ad1488142685c31a145d196ba70abb);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a86ea451f8a85999d38f7a441f8a0d09cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(ac4640c963d80f3f7338b6aa2db7f0542b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a4271a148d563f996e5da7a07edb69a62b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(aedb2f6782e88ab16ce219fed4d7e737db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a641323b7e372cfe2b32f7cc62c3e7903b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(ac4640c963d80f3f7338b6aa2db7f0542b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(ac1adf93c3498f072f95e02d484dc6d45b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(ad56c128a1f423438ddf6f100f81f5a31b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(ac4640c963d80f3f7338b6aa2db7f0542b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a796027f38b094748e5ec69e25050e68db);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a431c106f1bbfac72024b70bc1e1434f6b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a433a563b3f2de29990015aefc674cbfcb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a796027f38b094748e5ec69e25050e68db);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */